import { Navigate} from "react-router-dom";
import { useAuth } from "../components/hooks/useAuth";
function ProtectedRoute({ element: Component }) {
  const { isSignedin } = useAuth();
  return isSignedin ? Component : <Navigate to="/signin" />;
}

export default ProtectedRoute;
